module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "downArrow.fc9b72e1.svg";